(function () {
  "use strict";

  console.log("[location-logger] Script loaded");

  // Shopify location coordinates with accurate data and location IDs
  const LOCATION_COORDINATES = {
    Agouza: {
      lat: 30.055390944597903,
      lng: 31.209379628973227,
      locationId: 82358010021,
      address: "3645+4P Agouza, 21 شارع طلعت ناصبة طنطا, Giza, Agouza, Egypt",
    },
    Arabella: {
      lat: 29.991857566512888,
      lng: 31.432453467957863,
      locationId: 81188028581,
      address:
        "XCRM+P2Q New Cairo 1, محل رقم 7 الدور الأرضي منطقة الدبلوماسيين مول أرابيلا بدلا, Cairo",
    },
    "Hadayek ahram": {
      lat: 29.981930543197898,
      lng: 31.10373084688103,
      locationId: 82374328485,
      address:
        "X4J3+CFQ Al Haram, 307 شارع الثروة المعدنية, Giza, Haram, Egypt",
    },
    Main: {
      lat: 30.065109499432452,
      lng: 31.34294971694327,
      locationId: 82612355237,
      address:
        "385H+XFH, El-Rabae, Al Manteqah Al Oula, Nasr City, Cairo Governorate 4450133",
    },
    "Open air": {
      lat: 30.10839636211641,
      lng: 31.62426660613141,
      locationId: 82374394021,
      address:
        "4J5F+8J9 Second New Cairo, المركز التجاري السياحي الترفيهي المفتوح بمدينتي أوبن اير, Cairo",
    },
    "Palm hills 360": {
      lat: 30.01048753275786,
      lng: 31.019482836523046,
      locationId: 82374262949,
      address:
        "2259+RQX 6th of October City, بي ثالث بالامتداد السياحي الشرقي بمدينة السادس من اكتوبر",
    },
    Sodic: {
      lat: 30.016947038619133,
      lng: 31.517429213364935,
      locationId: 82357977253,
      address:
        "2G87+GQW New Cairo 1, شرقي للمستثمرين الحيوية بقطاع الإندلس شرق مدينة القاهرة الجديدة",
    },
  };

  // Haversine formula to calculate distance between two points in km
  function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  // Find nearest location from all Shopify locations
  function findNearestLocation(userLat, userLng) {
    let nearest = null;
    let minDistance = Infinity;

    for (const [name, location] of Object.entries(LOCATION_COORDINATES)) {
      const distance = calculateDistance(
        userLat,
        userLng,
        location.lat,
        location.lng
      );

      console.log(
        `[location-logger] Distance to ${name}:`,
        distance.toFixed(2),
        "km"
      );

      if (distance < minDistance) {
        minDistance = distance;
        nearest = {
          name: name,
          lat: location.lat,
          lng: location.lng,
          address: location.address,
          distance_km: distance,
        };
      }
    }

    return nearest;
  }

  // Fallback: IP-based location
  function fetchIpLocation() {
    console.log("[location-logger] Attempting IP-based location...");
    return fetch("https://ipapi.co/json/")
      .then((r) =>
        r.ok ? r.json() : Promise.reject(new Error("IP lookup failed"))
      )
      .then((data) => ({
        lat: data.latitude,
        lng: data.longitude,
        source: "ip",
      }))
      .catch((err) => {
        console.error("[location-logger] IP location error:", err);
        return { lat: null, lng: null, source: "ip-error", error: String(err) };
      });
  }

  // Detect user location using geolocation API or IP fallback
  function detectLocation() {
    return new Promise((resolve) => {
      if ("geolocation" in navigator) {
        const success = (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            source: "geolocation",
          };
          console.log("[location-logger] Geolocation success:", userLocation);
          resolve(userLocation);
        };

        const fail = (error) => {
          console.warn("[location-logger] Geolocation error:", error.message);
          console.log("[location-logger] Falling back to IP-based location...");
          fetchIpLocation().then(resolve);
        };

        try {
          navigator.geolocation.getCurrentPosition(success, fail, {
            timeout: 8000,
            enableHighAccuracy: false,
          });
        } catch (e) {
          console.error("[location-logger] Geolocation exception:", e);
          fetchIpLocation().then(resolve);
        }
      } else {
        console.warn("[location-logger] Geolocation not supported");
        fetchIpLocation().then(resolve);
      }
    });
  }

  // Main initialization function
  async function init() {
    console.log("[location-logger] Starting location detection...");

    try {
      const detected = await detectLocation();
      console.log("[location-logger] User location detected:", detected);

      if (!detected || detected.lat == null || detected.lng == null) {
        console.warn("[location-logger] No coordinates available");
        return;
      }

      const nearest = findNearestLocation(detected.lat, detected.lng);
      console.log("[location-logger] Nearest location:", nearest);

      // Store in localStorage for future use
      localStorage.setItem("userLocation", JSON.stringify(detected));
      localStorage.setItem("nearestLocation", JSON.stringify(nearest));

      // Dispatch custom event for other scripts to use
      window.dispatchEvent(
        new CustomEvent("locationDetected", {
          detail: {
            userLocation: detected,
            nearestLocation: nearest,
          },
        })
      );
    } catch (err) {
      console.error("[location-logger] Error detecting location:", err);
    }
  }

  // Auto-run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose helper functions globally for cart validation
  window.getNearestLocation = function () {
    const stored = localStorage.getItem("nearestLocation");
    return stored ? JSON.parse(stored) : null;
  };

  window.isLocationInRange = function (maxDistanceKm = 15) {
    const nearestLocation = window.getNearestLocation();

    if (!nearestLocation) {
      console.warn("[location-logger] No location detected yet");
      return false;
    }

    const inRange = nearestLocation.distance_km <= maxDistanceKm;

    console.log(
      `[location-logger] Distance check: ${nearestLocation.distance_km.toFixed(
        2
      )}km, Max: ${maxDistanceKm}km, In range: ${inRange}`
    );

    return inRange;
  };
})();
